import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { cacheKey } from "./constants";
import type { TeamMembersParams, TeamMembersPayload } from "./types";

export const getTeamMembersData = reactQueryTableFetcherAdapter(
  cacheKey,
  (
    signal: AbortSignal,
    { appGroupId, id, sortby, sortdir, limit = 10, start = 0 }: TeamMembersParams
  ): Promise<TeamMembersPayload> => {
    return fetch(
      `/app_settings/territories_data/${id}/members`,
      "GET",
      {
        app_group_id: appGroupId,
        sortby,
        sortdir,
        limit,
        start,
      },
      { signal }
    );
  }
);
